export default {
    OrderRuless: {
        Doc: 'Order No.',
        number: 'Third-party/internal Order No.',
        Channel: 'Channel',
        Store: 'Store',
        Sourcing: 'Sourcing Status',
        Order: 'Order time',
        Start: 'Start date',
        End: 'End date',
        Specify: 'Specify delivery',
        Re: 'Resourcing',
        form: {
            Third: 'Customer Order No.',
            Internal: 'CSG Order No.',
            Doc: 'Sourcing number',
            status: 'Sourcing Status',
            Product: 'Number of Item Lines',
            succeeded: 'Sourcing success',
            failed: 'Sourcing failure',
            reason: 'Reason for failure',
            store: 'Store',
            channel: 'Sales Channel',
            ordering: '3rd Party Order Time',
            time: 'Payment time',
            creation: 'Sourcing creation time',

            Please: 'Please select the "Resourcing failed" or "Partially resourced" status of the sourcing order to perform the resourcing operation',
            sure: 'Are you sure you want to resource?',
            Canceled: 'Cancelled',
            Shipment: 'Can only specify delivery for failed sourcing orders',
            want: 'Are you sure you want to cancel the sourcing of this order?',
            Cancellation: 'Cancellation successful',
        }
    }
};
